import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
const Ctx = createContext({
    theme: 'dark',
    setTheme: () => { },
    resolved: 'dark',
});
function resolve(theme) {
    if (theme === 'system') {
        return typeof window !== 'undefined' &&
            window.matchMedia('(prefers-color-scheme: light)').matches
            ? 'light'
            : 'dark';
    }
    return theme;
}
export function ThemeProvider({ children }) {
    const [theme, setThemeState] = useState(() => (typeof window !== 'undefined' && localStorage.getItem('theme')) || 'dark');
    const [resolved, setResolved] = useState(() => resolve(theme));
    useEffect(() => {
        const r = resolve(theme);
        setResolved(r);
        document.documentElement.dataset.theme = r;
        localStorage.setItem('theme', theme);
    }, [theme]);
    useEffect(() => {
        if (theme !== 'system')
            return;
        const mq = window.matchMedia('(prefers-color-scheme: light)');
        const onChange = () => setResolved(mq.matches ? 'light' : 'dark');
        mq.addEventListener('change', onChange);
        return () => mq.removeEventListener('change', onChange);
    }, [theme]);
    return _jsx(Ctx.Provider, { value: { theme, setTheme: setThemeState, resolved }, children: children });
}
export const useTheme = () => useContext(Ctx);
